import React, { ChangeEvent, Ref, FocusEvent } from "react";

import { Required, FieldWrapper, FieldWrapperProps } from "shared/components";
import { Spacer } from "shared/layout";
import { Icon } from "shared/styles";
import { RadioWrapper } from "./styles";

export interface RadioProps extends FieldWrapperProps {
  index?: number;
  label?: string | JSX.Element;
  icon?: React.ComponentType<any>;
  value: string;
  registerRef?: Ref<HTMLInputElement>;
  defaultChecked?: boolean;
  checked?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  size?: "lg" | "default";
}

export const Radio: React.FC<RadioProps> = ({
  name,
  value,
  index,
  label,
  icon,
  registerRef,
  required,
  checked,
  onChange,
  onBlur,
  error,
  defaultChecked,
  disabled,
  size,
  ...rest
}) => (
  <FieldWrapper name={name} error={error} {...rest}>
    <RadioWrapper error={!!error} size={size} disabled={disabled}>
      <label>
        <input
          ref={registerRef}
          type="radio"
          name={name}
          id={`${name}_${value}`}
          value={value}
          onChange={onChange}
          defaultChecked={defaultChecked}
          checked={checked}
          onBlur={onBlur}
          disabled={disabled}
        />
        <Spacer size="xs" spaceDirection="horizontal" align="center">
          {icon && <Icon as={icon} size="xxl" />}
          <span>
            {label}
            {required && <Required />}
          </span>
        </Spacer>
      </label>
    </RadioWrapper>
  </FieldWrapper>
);
